export * from "./generated/api";
export * from "./generated/api.schemas";
export { setBaseUrl, setAuthTokenGetter } from "./custom-fetch";
export type { AuthTokenGetter } from "./custom-fetch";

import { useQuery } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { CampaignStatus, CampaignSummary, CampaignDetail } from "./generated/api.schemas";

export type CampaignStatusFilter = CampaignStatus | "all";

type PaginationMeta = {
  total: number;
  page: number;
  limit: number;
  total_pages: number;
};

type CampaignListResponse = {
  data: CampaignSummary[];
  pagination: PaginationMeta;
};

export type RewardFilter = "all" | "reward" | "non-reward";

type CampaignListParams = {
  status: CampaignStatusFilter;
  search?: string;
  page?: number;
  limit?: number;
  sortCol?: string;
  sortDir?: "asc" | "desc";
  reward?: RewardFilter;
};

export function useListCampaignsByStatus({ status, search, page = 1, limit = 20, sortCol, sortDir, reward }: CampaignListParams) {
  const params = new URLSearchParams();
  if (status !== "all") params.set("status", status);
  if (search) params.set("search", search);
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (sortCol) params.set("sort_by", sortCol);
  if (sortDir) params.set("sort_dir", sortDir);
  if (reward === "reward") params.set("is_rewards_campaign", "true");
  if (reward === "non-reward") params.set("is_rewards_campaign", "false");

  const url = `/api/v1/hiring/campaigns?${params.toString()}`;

  return useQuery({
    queryKey: ["campaigns", status, search ?? "", page, limit, sortCol ?? "", sortDir ?? "", reward ?? "all"],
    queryFn: ({ signal }) => customFetch<CampaignListResponse>(url, { signal }),
  });
}

export type OfferStatusFilter = "all" | "sent" | "accepted";
